<template>
  <div>
    <van-tabs v-model="status" @change="tabChange">
      <van-tab title="停车中" name="0" />
      <van-tab title="离场中" name="1" />
      <van-tab title="已完成" name="2"/>
    </van-tabs>
    <div class="order-list">
      <van-list v-model="loading" :finished="finished" :finished-text="status==2?'* 仅显示近一年的停车记录' : '已加载完毕'" @load="load">
        <div v-for="order in ordersFormated" :key="order.orderId" class="order-card" @click="selectOrder(order)">
          <div class="order-cell">
            <div class="order-cell-left">{{order.startTime.substr(0, 16)}}</div>
            <div class="order-cell-right">{{order.orderId}}</div>
          </div>
          <div class="order-cell">
            <div class="order-cell-left order-parking-location">{{order.parkingLotName}}</div>
            <div class="order-cell-right order-parking-location">{{order.parkingSpotName || order.plateNumber}}</div>
          </div>
          <div class="order-cell">
            <div class="order-cell-left" v-if="order.canceled"><van-tag plain>已关闭</van-tag></div>
            <div class="order-cell-left" v-else-if="order.parkingStatus == 0"><van-tag plain type="primary">停车中</van-tag></div>
            <div class="order-cell-left" v-else-if="order.parkingStatus == 1"><van-tag type="success" plain>离场中</van-tag></div>
            <div class="order-cell-left parking-time" v-else>{{order.parkingTime | upperToMinutes | duration}}</div>
            <div class="order-cell-right">
              <span v-for="(coupon, key) in order.coupons" :key="key">&nbsp;
                <van-tag color="#7232dd" >{{coupon.name}}</van-tag>
                <span v-show="coupon.count>1"> &times;{{coupon.count}}</span>
              </span>
              &nbsp;<strong v-show="order.parkingStatus != 0">{{order.actualCharge}}元</strong>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!--
    <van-goods-action safe-area-inset-bottom>
      <div style="text-align: center; width: 100%; padding: 10px">
        <subscribe-button :once="false" msgKey="parking_payment"><a>车辆付费提醒</a></subscribe-button>
        <div style="color:gray; font-size:12px;padding:2px">点击订阅并同意后,车辆离场需要付费时,将收到推送通知</div>
      </div>
    </van-goods-action>
    -->
  </div>
</template>
<script>
import { Tabs, Tab, List, GoodsAction, GoodsActionButton, ActionSheet, Button, Loading, Tag} from 'vant';
import { coubineCoupons } from '../components/Coupon.vue';
import qs from "query-string";
import { router } from '../router';
// import SubscribeButtonVue from '../components/SubscribeButton.vue';

export default {
  components: {
    // 'subscribe-button' : SubscribeButtonVue,
    [Tabs.name] : Tabs,
    [Tab.name] : Tab,
    [List.name] : List,
    [GoodsAction.name] : GoodsAction,
    [GoodsActionButton.name] : GoodsActionButton,
    [ActionSheet.name] : ActionSheet,
    [Button.name] : Button,
    [Loading.name] : Loading,
    [Tag.name] : Tag,
    [GoodsAction.name] : GoodsAction,
    [GoodsActionButton.name] : GoodsActionButton
  },
  data() {
    return {
      actionPopupVisable: false,
      coupon : null,
      status: qs.parse(location.search).status || '0',
      page: 1,
      pageSize: 10,
      finished : false,
      loading : false,
      result: {
        rows: [],
        total: 0
      }
    };
  },
  computed: {
    ordersFormated() {
      return this.result.rows.map(order => ({...order, coupons : coubineCoupons(order.coupons)}));
    }
  },
  filters : {
    upperToMinutes(value) {
      return Math.ceil(value/60) * 60;
    }
  },
  methods: {
    tabChange() {
      this.page = 1;
      this.result = { rows: [], total: 0}
      this.finished = false;
      this.load();
    },
    selectOrder(order) {
      const { parkingStatus, orderId } = order;
      if (parkingStatus == 0) {
        router.push('/parking?orderId='+orderId)
      } else if (parkingStatus == 1) {
        router.push('/leaving?orderId='+orderId)
      }
    },
    async load(){
      this.loading = true;
      const lastStatus = this.status;
      const data = await this.$http.get('/order/query', { status: this.status, page: this.page, pageSize: this.pageSize});
      if (lastStatus == this.status) {
          if (this.page == 1) {
            this.result = data;
          } else {
            this.result.rows = this.result.rows.concat(data.rows);
          }
          if (this.page < Math.ceil(this.result.total / this.pageSize)) {
              this.page ++ ;    
          } else {
            this.finished = true
          }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="less" scoped>
  .action-popup{
    min-height: 350px;
    padding-top: 4px;
    display: flex;
    flex-direction: column;
  }
  .order-card {
    background-color: white;
    margin: 10px;
    padding: 15px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  }
  .order-cell{
    display: flex;
    justify-content: space-between;
    
  }
  .order-parking-location {
    color: gray;
    padding: 10px 0;
  }
  .parking-time {
    font-size: 12px;
    color: gray;
  }
</style>